import { useState, useEffect } from "react";
import { AppContext } from "./libs/contextLib";
import Routes from "./Routes";
import React from "react";
import { NotificationContainer } from "react-notifications";
import AppBar from "./components/NewHeader.js";
import { Actions as userActions } from "./core/redux/ducks/user";
import jwt_decode from "jwt-decode";
import { connect } from "react-redux";
import "react-notifications/lib/notifications.css";
import SearchProvider from "./contexts/Search";
import ThemeProvider from "./contexts/Theme";
import LanguageProvider from "./contexts/Language";

import Compose from "reactjs-compose";
import { Dialog } from "@material-ui/core";
import Onboarding from "./components/onboarding/Onboarding";

function App({ token, currentUser, userData }) {
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [openOnboarding, setOpenOnboarding] = useState(false);

  useEffect(() => {
    onLoad(token);
  }, []);

  useEffect(() => {
    console.log(userData.user);
    if (userData.user) {
      if (userData.user.isFirstLogin) setOpenOnboarding(true);
    }
  }, [userData.user]);

  async function onLoad(times) {
    const accessToken = await localStorage.getItem("access");
    if (accessToken) {
      try {
        let is_valid_token = validateToken(accessToken);
        if (is_valid_token) {
          userHasAuthenticated(true);
          currentUser();
        }
        // If token is not valid, ask for new token
        else {
          const refreshToken = await localStorage.getItem("refresh");
          await userActions.getNewToken(refreshToken);
          await onLoad(times);
        }
      } catch (e) {
        if (e !== "No current user") {
          // onError(e);
        }
      }
    } else {
      console.log("No access token found.");
    }
    setIsAuthenticating(false);
  }

  function validateToken(token) {
    try {
      let decoded = jwt_decode(token);
      let current_time = new Date().getTime() / 1000;
      return current_time < decoded.exp;
    } catch (e) {
      console.log("Invalid token error: " + e);
    }
  }

  return (
    !isAuthenticating && (
      <div className="App">
        <Compose components={[ThemeProvider, SearchProvider, LanguageProvider]}>
          <AppContext.Provider
            value={{ isAuthenticated, userHasAuthenticated }}
          >
            <AppBar />
            {/* {isAuthenticated ? <Sidebar /> : null} */}
            <div className="app-content">
              <Dialog
                open={openOnboarding}
                onClose={() => setOpenOnboarding(false)}
              >
                <Onboarding onClose={() => setOpenOnboarding(false)} />
              </Dialog>
              <Routes />
            </div>
          </AppContext.Provider>
          <NotificationContainer />
        </Compose>
      </div>
    )
  );
}

const mapStateToProps = (state) => {
  return {
    userData: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    currentUser: () => userActions.currentUser(dispatch),
    // getNewToken: () => dispatch(userActions.getNewToken()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
